export default __webpack_public_path__ + "static/media/product1.7d67457e.jpg";